// extracted by mini-css-extract-plugin
export default {"container":"_3C5iu","main":"_1br0s","viewer_classic":"E6Ct4","viewerClassic":"E6Ct4","viewer_x":"_2Pjn9","viewerX":"_2Pjn9"};